
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import CardRed from '@/components/Shared/CardRed.vue';
  import TextWithBorder from '@/components/Shared/TextWithBorder.vue';
  import {authModule, i18nModule} from '@/utils/store-acessor';
  import NavBar from '@/components/NavBar/NavBar.vue';
  import {changeNavbarTheme, NavBarTheme, navDarkTheme, navLightTheme} from '@/components/NavBar/navbar-theme';
  import {LocaleSelectorType} from '@/store/i18n.store.module';

  interface ScrollEvent {
    [key: string]: {
      isAboveViewport: boolean
      isBelowViewport: boolean
      isFullyInViewport: boolean
      isInViewport: boolean
    }
  }

  interface SectionNineItem {
    img: any;
    html: string;
  }

  @Component({
    components: {
      NavBar,
      TextWithBorder,
      CardRed
    },
    metaInfo() {
      return {
        title: 'Ikone'
      };
    },
  })
  export default class AboutNew extends Vue {
    @authModule.Getter('isAuthenticated') readonly isAuthenticated!: boolean;
    @i18nModule.Getter('locale') locale!: LocaleSelectorType;
    section9Items: SectionNineItem[] = [
      {
        img: require('@/assets/images/about-new/hand.png'),
        html: 'new_about.section_9.p1'
      },
      {
        img: require('@/assets/images/about-new/002-dashboard.png'),
        html: 'new_about.section_9.p2'
      },
      {
        img: require('@/assets/images/about-new/003-research.png'),
        html: 'new_about.section_9.p3'
      },
      {
        img: require('@/assets/images/about-new/004-network.png'),
        html: 'new_about.section_9.p4'
      }
    ]

    updateState(element: ScrollEvent) {
      const theme = this.selectTheme(element);
      changeNavbarTheme(theme);
    }

    selectTheme(element: ScrollEvent): NavBarTheme {
      const {
        aboutSection1,
        aboutSection2,
        aboutSection3,
        aboutSection4,
        aboutSection5,
        aboutSection6,
        aboutSection7,
        aboutSection8,
        aboutSection9,
        aboutSection10,
        aboutSection11,
        aboutSection12,
        aboutSection13,
      } = element;
      if (this.$vuetify.breakpoint.mdAndUp) {
        if (aboutSection1?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection2?.isInViewport) {
          return navDarkTheme;
        }
        if (aboutSection3?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection4?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection5?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection6?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection7?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection8?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection9?.isInViewport) {
          return navDarkTheme;
        }
        if (aboutSection10?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection11?.isInViewport) {
          return navDarkTheme;
        }
        if (aboutSection12?.isInViewport) {
          return navLightTheme;
        }
        if (aboutSection13?.isInViewport) {
          return navLightTheme;
        }
      }
      return navLightTheme;
    }
  }
